// ExampleList.tsx
import { makeStyles } from "@fluentui/react-components";
import { Example } from "./Example";
import { tokens } from "../../theme";
import { brand } from "@brand";

// =============================================================================
// TOKEN SHORTCUTS
// =============================================================================

const t = {
    // Spacing
    spacingVerticalM: tokens.primitives["spacing-Vertical-M"],
    spacingHorizontalM: tokens.primitives["spacing-Horizontal-M"],
    spacingHorizontalL: tokens.primitives["spacing-Horizontal-L"],
    spacingHorizontalXl: tokens.primitives["spacing-Horizontal-XL"], // 20px
    spacingHorizontalXxl: tokens.primitives["spacing-Horizontal-XXL"], // 24px
    spacingHorizontalXxxl: tokens.primitives["spacing-Horizontal-XXXL"] // 32px
};

// =============================================================================
// STYLES
// =============================================================================

// ExampleList.tsx - Update the styles

const useStyles = makeStyles({
    container: {
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: `0 ${t.spacingHorizontalL}`,

        "@media (max-width: 600px)": {
            padding: `0 ${t.spacingHorizontalXxxl}`
        }
    },

    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: t.spacingHorizontalM,
        listStyle: "none",
        margin: 0,
        padding: 0,

        "@media (max-width: 1024px)": {
            gridTemplateColumns: "repeat(2, 1fr)"
        },

        "@media (max-width: 600px)": {
            gridTemplateColumns: "1fr",
            gap: t.spacingVerticalM
        }
    },

    gridItem: {
        display: "flex"
    }
});

// =============================================================================
// DATA
// =============================================================================

export type ExampleModel = {
    text: string;
    value: string;
};

const EXAMPLES: ExampleModel[] = brand.exampleQuestions.map(q => ({ text: q, value: q }));

// =============================================================================
// COMPONENT
// =============================================================================

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <ul className={styles.grid} aria-label="Example questions you can ask">
                {EXAMPLES.map((example, index) => (
                    <li key={index} className={styles.gridItem}>
                        <Example text={example.text} value={example.value} onClick={onExampleClicked} />
                    </li>
                ))}
            </ul>
        </div>
    );
};
